export function isCleanInput(text: string): boolean {
  // 금지할 문자 범위들 (정규식 그룹으로 묶음)
  const forbiddenPattern = /[\u0300-\u036F\u1DC0-\u1DFF\uFE20-\uFE2F\u20D0-\u20FF]/;
  return !forbiddenPattern.test(text);
}
